import React from "react";

// Small glyphs that draw with currentColor: the phone's signal bars and the window buttons'.

export const SignalIcon = ({ className = "w-5 h-4" }) => (
  <svg viewBox="0 0 20 13" fill="currentColor" className={className} aria-hidden="true">
    <rect x="0" y="8.5" width="3.6" height="4.5" rx="1" />
    <rect x="5.4" y="6" width="3.6" height="7" rx="1" />
    <rect x="10.8" y="3" width="3.6" height="10" rx="1" />
    <rect x="16.2" y="0" width="3.6" height="13" rx="1" />
  </svg>
);

// Traffic-light glyphs, shown on hover.
export const CloseGlyph = () => (
  <svg viewBox="0 0 12 12" className="traffic-glyph" aria-hidden="true">
    <path d="M3.5 3.5l5 5M8.5 3.5l-5 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

export const MinimizeGlyph = () => (
  <svg viewBox="0 0 12 12" className="traffic-glyph" aria-hidden="true">
    <path d="M2.8 6h6.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const ZoomGlyph = () => (
  <svg viewBox="0 0 12 12" className="traffic-glyph" aria-hidden="true">
    <path d="M3.7 3.7h3.4L3.7 7.1zM8.3 8.3H4.9l3.4-3.4z" fill="currentColor" />
  </svg>
);
